import styled from 'styled-components';
import { MQS } from '../../../app/common/constants/styles';

export const ServiceInfo = styled.div`
    width: 100%;
`;

export const ServiceHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 30px;

    @media all and (min-width: ${MQS.mq2Min}) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

export const ServiceStatus = styled.div`
    display: flex;
    margin-bottom: 10px;

    & > div:nth-child(2) {
        margin-left: 20px;
    }
`;
